import InfoLinkCard from './InfoLinkCard';
export default InfoLinkCard;
